<script setup>
import { computed } from 'vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';

const props = defineProps({
    status: String,
});

const form = useForm();

const submit = () => {
    form.post(route('verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
    <BreezeGuestLayout>
        <Head title="Email Verification" />

        <section class="main k">

            <h2 class="login_title c-heading-h2">メールを確認してユーザー登録を完了させてください。</h2>

            <p style="margin-bottom: 24px;">ご入力いただいたメールアドレス宛にメールを送信しました。<br>
            メールに記載されているアドレスをクリックして、ユーザー登録を完了させてください。<br>
            メールが届いていない場合は、以下の「認証メールを再送する」ボタンをクリックしてください。</p>

            <p v-if="verificationLinkSent" style="margin-bottom: 24px;">
                認証メールを送信しました。
            </p>

            <form @submit.prevent="submit">
                <div>
                    <BreezeButton class="c-button" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        認証メールを再送する
                    </BreezeButton>

                    <Link :href="route('logout')" method="post" class="c_text-link">ログアウト</Link>
                </div>
            </form>

        </section>
    </BreezeGuestLayout>
</template>
